import { Modal } from "antd";
import { Tabs } from "antd";
import ChangePassword from "./ChangePassword";
import UserInfo from "./UserInfo";
import styles from "./modalInfoUser.module.scss";

const onChange = (key: any) => {};
const items = [
  {
    key: "info",
    label: "Cập nhật thông tin",
    children: <UserInfo />,
  },
  {
    key: "password",
    label: "Đổi mật khẩu",
    children: <ChangePassword />,
  },
];
function ManageAccount(props: any) {
  let { isModalOpen, handleCancel } = props;

  return (
    <>
      <Modal
        title="Quản lý người dùng"
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
        maskClosable={false}
        className={styles["modal-change-info-user"]}>
        <Tabs defaultActiveKey="info" items={items} onChange={onChange} />
      </Modal>
    </>
  );
}

export default ManageAccount;
